<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="barCodeSearch"
        label="Buscar pelo código de barras"
        single-line
        hide-details
        @change="searchWithBarCode"
        clearable
        @click:clear="clearBarCodeSearch"
      />
      <v-spacer />
      <v-btn color="success" dark small @click="showBatchDialog">
        <span v-if="!generating_batch">Gerar Lote de Usinas </span>
        <v-icon v-if="!generating_batch" right dark>add</v-icon>
        <span v-if="generating_batch">Gerando lote...</span>
        <v-progress-circular
          v-if="generating_batch"
          indeterminate
          color="white"
          size="17"
          class="mr-2"
        ></v-progress-circular>
      </v-btn>
      <v-dialog v-model="generateBatchDialog" max-width="600">
        <v-card>
          <v-card-title class="headline red lighten-2 white--text">
            <v-icon color="white darken-2 pr-2" large
              >mdi-alert-circle-outline</v-icon
            >
            <span class="ml-2">Gerar lote de usina</span>
          </v-card-title>
          <v-card-text>
            Tem certeza de que deseja realizar esta ação?
          </v-card-text>
          <v-card-text>
            <b>Obs: Esta ação NÃO pode ser desfeita.</b>
          </v-card-text>
          <v-card-actions>
            <v-btn color="red" @click="closeBatchDialog">Cancelar</v-btn>
            <v-btn color="green" @click="createUsinasBatch">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loadingDialog" max-width="600" persistent>
        <v-card>
          <v-card-title class="headline green lighten-2 white--text">
            <v-icon color="white darken-2 pr-2" large>
              mdi-alert-circle-outline
            </v-icon>
            <span class="ml-2">Gerando lote de usina</span>
          </v-card-title>
          <v-card-text>
            <v-progress-circular
              indeterminate
              color="green"
              size="17"
              class="mr-2"
            ></v-progress-circular>
            <span class="ml-2"
              >Lote está sendo criado. Por favor, aguarde!</span
            >
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-spacer />
      <v-text-field
        label="Arquivo de Retorno"
        @click="onPickFile"
        v-model="fileName"
        prepend-icon="attach_file"
      ></v-text-field>
      <input
        style="display: none"
        @change="detectFiles($event, 'retorno')"
        accept="text/plain"
        type="file"
        ref="remessaFile"
      />
    </v-card-title>
    <div v-if="currentFile">
      <v-progress-linear
        v-model="progress"
        color="light-blue"
        height="25"
        reactive
      >
        <strong>{{ progress }} %</strong>
      </v-progress-linear>
    </div>
    <div v-if="loadingBankBatchsUsinas && !loadingTable">
      <v-progress-linear
        indeterminate
        color="purple"
        height="2"
        width="10"
        class="mt-0 mb-2"
      ></v-progress-linear>
    </div>
    <v-data-table
      :headers="headers"
      :items="filteredBankBatches"
      :pagination.sync="pagination"
      no-data-text="Nenhum lote encontrado"
    >
      <template v-slot:items="props">
        <td>{{ props?.item?.scheduled_date | formatarDate }}</td>
        <td>{{ props.item && props.item.updated_at | formatarDate }}</td>
        <td>
          <v-chip
            :color="props.item.status | batchStatusColor"
            text-color="white"
          >
            {{ props.item.status | batchStatus }}
          </v-chip>

          <v-tooltip bottom v-if="props.item.contains_billing_error">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="error">mdi-alert-circle</v-icon>
            </template>
            <span>Erro de fatura dentro do lote</span>
          </v-tooltip>
        </td>

        <!-- Quantidade de Registros do Lote -->
        <td class="text-xs-center">{{ props.item.billets_count }}</td>

        <!-- Valor Total do Lote -->
        <td class="text-xs-center">
          <span v-if="props.item.total_amount">R$</span>
          {{ props.item.total_amount | formatCurrency }}
        </td>

        <!-- Endereço do Arquivo de Remessa -->
        <td class="text-xs-center">
          <v-icon
            v-if="props.item.batch_url"
            @click="downloadFile(props.item.batch_url)"
            >download</v-icon
          >
        </td>

        <!-- Endereço do Arquivo de Retorno de Agendamento -->
        <td class="text-xs-center">
          <v-icon
            v-if="props.item.scheduling_return_url"
            @click="downloadFile(props.item.scheduling_return_url)"
            >download</v-icon
          >
        </td>

        <!-- Endereço do Arquivo de Retorno de Pagamento -->
        <td class="text-xs-center">
          <v-icon
            v-if="props.item.payment_return_url"
            @click="downloadFile(props.item.payment_return_url)"
            >download</v-icon
          >
        </td>

        <!-- Endereço do Comprovante de Pagamento -->
        <td class="text-xs-center">
          <v-icon
            v-if="props.item.receipt_url"
            @click="downloadFile(props.item.receipt_url)"
            >download</v-icon
          >
          <v-btn
            v-else
            color="blue"
            flat
            icon
            @click="uploadReceipt(props.item.id)"
          >
            <v-icon right dark color="orange">mdi-cloud-upload</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center">
          <v-btn
            flat
            icon
            color="grey darken-1"
            @click="openBillingBatchList(props.item.id)"
            :disabled="loading"
          >
            <v-icon>view_list</v-icon>
          </v-btn>
        </td>
      </template>
      <template v-slot:no-data v-if="loadingTable">
        <div class="text-xs-center">
          Carregando tabela
          <v-progress-circular
            indeterminate
            color="#7C3DFF"
            size="17"
          ></v-progress-circular>
        </div>
      </template>
    </v-data-table>
    <upload-receipt />

    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>

    <v-dialog
      v-model="billingBatchListDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      lazy
    >
      <v-card>
        <v-toolbar dark color="blue">
          <v-toolbar-title class="white--text" dark
            >Lista de Contas do Lote {{ batch_id }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark flat @click="billingBatchListDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <billing-batch-list-usinas :batch_id="batch_id" :search_text="search" />
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { firestorageBank } from "@/firebase/firestorageBank";
import dayjs from "dayjs";
import firebase from "firebase";
import { mapActions, mapState } from "vuex";
import { eventBus } from "../../main";
import {
  generateBatch,
  getBatchWithBarCode,
  scheduleBatch,
} from "../../services/batches";
import UploadReceipt from "../bankBatchs/UploadReceipt.vue";
import BillingBatchListUsinas from "./BillingBatchListUsinas";

export default {
  components: { BillingBatchListUsinas, UploadReceipt },
  data() {
    return {
      search: "",
      barCodeSearch: "",
      filteredBankBatches: [],
      loadingTable: true,
      generating_batch: false,
      headers: [
        {
          text: "Data de Agendamento",
          align: "left",
          value: "scheduled_date",
        },
        {
          text: "Data de Atualização",
          align: "left",
          value: "updated_at",
        },
        {
          text: "Status",
          align: "left",
          value: "status",
        },
        { text: "Quantide de Reg.", value: "billets_count" },
        { text: "Valor Pagto.", value: "total_amount" },
        { text: "Remessa", value: "file_name" },
        { text: "Agendamento", value: "file_name2" },
        { text: "Pagamento", value: "file_name3" },
        { text: "Comprovante", value: "file_name3" },
        {
          text: "Lista de Faturamentos do Lote",
          value: "billetsBankBatchList",
        },
      ],
      pagination: {
        rowsPerPage: 10,
        sortBy: "scheduled_date",
        descending: true,
      },
      loading: false,

      color: "",
      snackMessage: "",
      snackbar: false,
      bstatus: [
        {
          label: "Agendar",
          value: "to_schedule",
          color: "orange",
        },
        {
          label: "Agendado",
          value: "scheduled",
          color: "blue",
        },
        {
          label: "Pago",
          value: "paid",
          color: "green",
        },
      ],
      start_at: new Date(),
      end_at: new Date(),
      remessaFile: null,
      comprovFile: null,
      processing: false,
      fileUrl: null,
      progress: 0,
      progressComprov: 0,
      currentFile: null,
      currentcomprovFile: null,
      billingBatchListDialog: false,
      batch_id: null,
      fileName: null,
      fileNameComprov: null,
      generateBatchDialog: false,
      loadingDialog: false,
    };
  },
  async mounted() {
    if (!this.bankBatchsUsinas || this.bankBatchsUsinas?.length <= 0) {
      await this.getBankBatchsUsinas();
    }
    this.filteredBankBatches = this.bankBatchsUsinas;
  },
  watch: {
    bankBatchsUsinas() {
      if (this.bankBatchsUsinas?.length > 0) {
        this.loadingTable = false;
      }
    },
  },
  computed: {
    ...mapState("uniquebilling", [
      "bankBatchsUsinas",
      "loadingBankBatchsUsinas",
    ]),
    ...mapState(["user"]),

    filteredTypes() {
      return (utility_company, type) => {
        if (!utility_company) {
          utility_company = "cemig";
        }
        if (!type) {
          return utility_company;
        }
        return `${utility_company} ${type}`;
      };
    },
    filteredItems() {
      if (this.search) {
        const searchTerm = this.search;
        return this.bankBatchsUsinas.filter((item) =>
          this.customFilter(item, searchTerm),
        );
      } else {
        return this.bankBatchsUsinas;
      }
    },
    isAdmin() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("admin") >= 0) {
        return true;
      }
      return false;
    },
    isFinancial() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("financial") >= 0) {
        return true;
      }
      return false;
    },
    isPartnerManagement() {
      let currentUserGroups = this.user.group.toString();
      if (currentUserGroups.indexOf("partner_management") >= 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions("uniquebilling", [
      "getBankBatchsUsinas",
      "getBankBatchByScheduledDate",
      "markUserEmailBatch",
    ]),
    onPickFile() {
      this.$refs.remessaFile.click();
    },
    selectFile(file) {
      this.progress = 0;
      this.currentFile = file;
    },
    formatBankingStatus(status) {
      // console.log('s: ', status)
      if (!status || status === "") return this.bstatus[0];
      let f = (status = this.bstatus.filter((el) => {
        return el.value === status;
      }));
      return f[0];
    },
    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    detectFiles(e, type) {
      let fileList = e.target.files || e.dataTransfer.files;

      Array.from(Array(fileList.length).keys()).map((x) => {
        if (type === "retorno") {
          this.uploadFile(fileList[x]);
          this.currentFile = fileList[x];
        } else if (type === "comprov") {
          this.uploadComprovFile(fileList[x]);
          this.currentcomprovFile = fileList[x];
        }
      });
    },
    async uploadFile(file) {
      try {
        console.log("start uploading file: ", file);
        if (file && file.name) {
          this.processing = true;

          const filePath = `retornos/${file.name}`;
          const metadata = { contentType: file.type };

          var uploadTask = firestorageBank
            .ref()
            .child(filePath)
            .put(file, metadata);

          // Listen for state changes, errors, and completion of the upload.
          uploadTask.on(
            "state_changed", //firestorageBank.TaskEvent.STATE_CHANGED, // or 'state_changed'
            (snapshot) => {
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              var progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              this.progress = progress;
              console.log("Upload is " + progress + "% done");
              switch (snapshot.state) {
                case firebase.storage.TaskEvent.PAUSED: // or 'paused'
                  console.log("Upload is paused");
                  break;
                case firebase.storage.TaskEvent.RUNNING: // or 'running'
                  console.log("Upload is running");
                  break;
              }
            },
            (error) => {
              // A full list of error codes is available at
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case "storage/unauthorized":
                  // User doesn't have permission to access the object
                  this.snack(
                    "Não há autorização para o upload do arquivo.",
                    "red",
                  );
                  break;
                case "storage/canceled":
                  // User canceled the upload
                  this.snack("Upload cancelado.", "red");
                  break;

                // ...

                case "storage/unknown":
                  this.snack(
                    "Ocorreu um erro inesperado, tente novamente.",
                    "red",
                  );
                  // Unknown error occurred, inspect error.serverResponse
                  break;
              }
            },
            () => {
              // Upload completed successfully, now we can get the download URL
              uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log("File available at", downloadURL);
                this.snack(
                  "Upload de Arquivo de Retorno realizado com sucesso! O Processamento do arquivo acontecerá em background.",
                  "green",
                );
              });
            },
          );
          console.log("filePath: ", filePath);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.processing = false;
      }
    },
    uploadReceipt(id) {
      eventBus.$emit("uploadReceipt", { show: true, id: id });
    },
    downloadFile(path) {
      const resumeRef = firestorageBank.refFromURL(path);

      resumeRef
        .getDownloadURL()
        .then(async (url) => {
          window.open(url, "_blank");
        })
        .catch((error) => {
          // Handle any errors
          switch (error.code) {
            case "storage/object-not-found":
              // File doesn't exist
              console.error("File doesn't exist");
              break;

            case "storage/unauthorized":
              // User doesn't have permission to access the object
              console.error(
                "User doesn't have permission to access the object",
              );
              break;

            case "storage/canceled":
              // User canceled the upload
              console.error("User canceled the upload");
              break;

            case "storage/unknown":
              // Unknown error occurred, inspect the server response
              console.error(
                "Unknown error occurred, inspect the server response",
              );
              break;
            default:
              break;
          }
        });
    },

    openBillingBatchList(id) {
      this.batch_id = id;
      this.billingBatchListDialog = true;
    },

    customFilter(item, searchTerm) {
      for (const key of item) {
        console.log("item", item);
        console.log("key", key);
        if (key.includes(searchTerm)) {
          return true;
        }
      }
      return false;
    },
    filterBankBatches() {
      if (!this.search) {
        this.filteredBankBatches = this.bankBatchsUsinas;
        return;
      }
      const formattedSearch = this.formatSearchDate(this.search);
      const filteredObject = this.bankBatchsUsinas.filter((objeto) => {
        return Object.values(objeto).some((valor) => {
          if (typeof valor === "string") {
            return valor.includes(formattedSearch);
          } else if (typeof valor === "number") {
            return String(valor).includes(formattedSearch);
          }
          return false;
        });
      });

      this.filteredBankBatches = filteredObject;
    },

    formatSearchDate(search) {
      // Verifica se a pesquisa está no formato "DD-MM"
      const parts = search.split("-");
      if (parts.length === 2) {
        return parts.reverse().join("-");
      }
      return search; // Se já estiver no formato "MM-DD", não faz nada
    },
    showBatchDialog() {
      this.generateBatchDialog = true;
    },
    closeBatchDialog() {
      this.generateBatchDialog = false;
    },

    async createUsinasBatch() {
      this.generating_batch = true;
      this.generateBatchDialog = false;

      try {
        const today = dayjs();
        let next_day = Infinity;
        let next_batch;
        for (let i = 0; i < this.filteredBankBatches.length; i++) {
          const scheduledDate = dayjs(
            this.filteredBankBatches[i].scheduled_date,
          );
          const diff = scheduledDate.diff(today, "day");
          if (diff < next_day && diff >= 0) {
            next_day = diff;
            next_batch = dayjs(
              this.filteredBankBatches[i].scheduled_date,
            ).format("DD/MM/YYYY");
          }
        }
        this.loadingDialog = true;
        const apropriate_batch =
          await this.getBankBatchByScheduledDate(next_batch);
        const agend = await scheduleBatch();
        const generate = await generateBatch("usinas", apropriate_batch);
        if (generate.data.success && agend.data.success) {
          const data = {
            user_email: this.user.email,
            batch_id: apropriate_batch,
          };
          await this.markUserEmailBatch(data);
          this.snack("Lote de usinas gerado com sucesso!", "green");
        } else {
          this.snack("Erro ao gerar lote de usinas.", "red");
        }
      } catch (error) {
        this.snack("Erro ao gerar lote de usinas.", "red");
      }
      this.generating_batch = false;
      this.loadingDialog = false;
    },

    async searchWithBarCode(search) {
      if (!search || search.trim() == "") {
        this.filteredBankBatches = this.bankBatchsUsinas;
        return;
      }

      this.loadingTable = true;
      this.filteredBankBatches = [];
      console.time("pesquisa");
      const batchIds = await getBatchWithBarCode(search);
      console.timeEnd("pesquisa");
      if (!batchIds) {
        this.snack(
          "Não foi possível encontrar o lote com o código de barras informado.",
          "red",
        );
        this.filteredBankBatches = this.bankBatchsUsinas;
      } else {
        this.filteredBankBatches = this.bankBatchsUsinas.filter((batch) => {
          return batchIds.includes(batch.id);
        });
      }
      this.loadingTable = false;
    },
    clearBarCodeSearch() {
      ((this.barCodeSearch = ""),
        (this.filteredBankBatches = this.bankBatchsUsinas));
    },
  },
};
</script>
<style scoped>
.overdue {
  color: red;
}
#loading {
  max-width: fit-content;
  margin: 5px auto !important;
}
</style>
